import Api from '../../../common/services/api';
import * as i18n from '../../../i18n';
import * as Analytics from '../../../../client/analytics';

export const RECEIVE_PROFILE = 'core/RECEIVE_PROFILE';

export default () => async (dispatch) => {
  const { data: user } = await Api.get(window.subdomainId ? `/v3/users/me?whitelabel_organisation_id=${window.subdomainId}` : '/v3/users/me');

  Analytics.identify(user.id);

  // Update language of app to
  i18n.changeLanguage(user.language_locale);

  if (window.Raven) window.Raven.setUserContext(user);

  if (window.Intercom) {
    window.Intercom('boot', { // eslint-disable-line new-cap
      user_id: user.id,
      name: user.full_name,
      email: user.email,
      username: user.username,
      hide_default_launcher: true,
      language_override: user.language_locale,
    });
  }

  return dispatch({
    type: RECEIVE_PROFILE,
    user,
  });
};
